import React from 'react';
import PropTypes from 'prop-types';
import { get, getOr } from 'lodash/fp';
import { Table } from 'rsuite';

const { Cell } = Table;

const FileValueCell = ({ rowData, dataKey, valueLabel, ...props }) => {
  const value = get(`file.${dataKey}`, rowData);
  return (
    <Cell {...props} className="link-group">
      {getOr(value, value, valueLabel)}
    </Cell>
  );
};

FileValueCell.propTypes = {
  rowData: PropTypes.shape({}),
  dataKey: PropTypes.string.isRequired,
  valueLabel: PropTypes.shape({})
};

FileValueCell.defaultProps = {
  rowData: null,
  valueLabel: null
};

export default FileValueCell;
